export default [
     {
          "id": "1",
          "staffName": "Khalid maha",
          "staffImg": "../images/rec5.png",
          "staffPosition": "Genral",
          "nation": "Ghana",
          "email": "khalidmaha123@gmail.com",
          "dob": "18/09/1980",
          "djoin": "12/12/2021",
          "state": "Kumasi",
          "add": "4, allen gate, kumasi ghana",
          "staff":" 1212BD2021",
          "number": "+267780897543"
     },
     {
          "id": "2",
          "staffName": "Elena jones",
          "staffImg": "../images/rec6.png",
          "staffPosition": "Surgical",
          "nation": "South Africa",
          "email": "elenajone23@gmail.com",
          "dob": "18/09/1989",
          "djoin": "12/09/2021",
          "state": "Pretoria",
          "add": "4, allen gate, pretoria SA",
          "staff":" 1209BD2021",
          "number": "+267780897543"

     },
     {
          "id": "3",
          "staffName": "Richard Mcall",
          "staffImg": "../images/rec7.png",
          "staffPosition": "Gynacology",
          "nation": "United Kingdom",
          "email": "richadmcall113@gmail.com",
          "dob": "18/09/1990",
          "djoin": "21/02/2021",
          "state": "England",
          "add": "407, John stones road england",
          "staff":" 1202AE2021",
          "number": "+44780897543"

     },
     {
          "id": "4",
          "staffName": "Micheal Jnr",
          "staffImg": "../images/rec7.png",
          "staffPosition": "Gynacology",
          "staffView": "view Profile",
          "nation": "USA",
          "email": "jnr323@yahoo.com",
          "dob": "18/09/1995",
          "djoin": "12/05/2022",
          "state": "Califonia",
          "add": "califonia road",
          "staff":" 1205FR2022",
          "number": "+167780897543"
     },
]